import { useState } from "react";
import { MessageCircle, X } from "lucide-react";

const WHATSAPP_NUMBER = "917302209481"; // K-Walk atelier
const WHATSAPP_MESSAGE = "Hi K-Walk! I'd like to know more about your shoes.";

export default function WhatsAppFloat() {
  const [open, setOpen] = useState(false);
  const href = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(WHATSAPP_MESSAGE)}`;

  return (
    <div className="fixed bottom-6 right-6 z-40 flex flex-col items-end gap-3">
      {open && (
        <div
          className="bg-white border border-[#e5e5e5] shadow-xl p-5 max-w-xs"
          data-testid="whatsapp-card"
        >
          <div className="flex items-start justify-between mb-3">
            <div className="label-eyebrow">Need something special?</div>
            <button
              onClick={() => setOpen(false)}
              className="text-[#666] hover:text-[#111]"
              aria-label="Close"
            >
              <X size={14} />
            </button>
          </div>
          <p className="text-sm text-[#111] leading-relaxed">
            Custom sizing, colors, or a bespoke pair? Chat with our atelier on WhatsApp — we
            usually reply in under an hour.
          </p>
          <a
            href={href}
            target="_blank"
            rel="noopener noreferrer"
            className="mt-4 inline-flex items-center gap-2 bg-[#111] text-white px-5 py-3 text-xs uppercase tracking-widest hover:bg-[#333] transition-colors"
            data-testid="whatsapp-chat-link"
          >
            <MessageCircle size={14} /> Chat on WhatsApp
          </a>
        </div>
      )}
      <button
        onClick={() => setOpen(!open)}
        className="w-14 h-14 rounded-full bg-[#25D366] text-white shadow-lg flex items-center justify-center hover:scale-110 transition-transform"
        aria-label="Open WhatsApp chat"
        data-testid="whatsapp-float-button"
      >
        <MessageCircle size={24} />
      </button>
    </div>
  );
}
